<template>
  <div v-loading="loading">
    <div class="header">
      <el-select v-model="selectedBoard" @change="getContractors">
        <el-option v-for="board in boards" :key="board.id" :value="board.id"
                   :label="board.title"/>
      </el-select>
      <el-button type="primary" @click="$router.push({name: 'ContractorsSync'})">Pudratchi o'zgartirish</el-button>
    </div>
    <el-table :data="tableData" border height="calc(100vh - 250px)">
      <el-table-column type="index" label="T/r" :index="indexMethod"/>
      <el-table-column prop="title" label="Pudratchi nomi"/>
      <el-table-column prop="acc_number" label="Hisob raqami"/>
      <el-table-column prop="inn" label="STIR"/>
      <el-table-column prop="contract_time" label="Shartnoma sanasi">
        <template #default="scope">
          {{ $moment(scope.row.contract_time).format('DD.MM.YYYY') }}
        </template>
      </el-table-column>
      <el-table-column prop="added_at" label="Yaratilgan sana">
        <template #default="scope">
          {{ $moment(scope.row.created_at).format('DD.MM.YYYY') }}
        </template>
      </el-table-column>
    </el-table>

    <div class="pagination">
      <div>
        Buyurtmachilar soni: {{ totalCount }}
      </div>
      <el-pagination
          background layout="sizes, prev, pager, next"
          :total="totalCount"
          v-model:page-size="limit"
          v-model:current-page="currentPage"
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
      />
    </div>
  </div>
</template>

<script>
import {ElNotification} from "element-plus";

export default {
  name: "ContractorsList",
  data() {
    return {
      loading: false,
      tableData: [],
      boards: [],
      selectedBoard: null,

      totalCount: 0,
      limit: 20,
      currentPage: 1,
    }
  },
  methods: {
    indexMethod(index) {
      return index + (this.currentPage - 1) * this.limit + 1
    },
    handleCurrentChange() {
      this.$router.replace({query: {...this.$route.query, page: this.currentPage}});
      this.getContractors()
    },
    handleSizeChange() {
      this.$router.replace({query: {...this.$route.query, size: this.limit, page: 1}});
      this.currentPage = 1;
      this.getContractors()
    },
    getContractors() {
      this.loading = true
      this.$http.get('api/v1/chronology/contractors', {
        params: {
          limit: this.limit,
          offset: this.limit * (this.currentPage - 1),
          board_id: this.selectedBoard
        }
      }).then(({data}) => {
        this.tableData = data.contractors
        this.totalCount = data.count
      }).catch(({response}) => {
        ElNotification.error({
          message: response.data.message || "Ma'lmumot yuklasda xatolik sodir bo'ldi!"
        })
      }).finally(() => {
        this.loading = false
      })
    },
    getBoards() {
      this.$http.get(`api/v1/boards`,{params:{status:1}}).then(({data}) => {
        this.boards = data.boards;
        this.selectedBoard = this.boards[0].id
        this.getContractors()
      }).catch((err) => {
        console.error('boards fetch error', err)
      })
    },
  },
  mounted() {
    if (this.$route.query.size) {
      this.limit = parseInt(this.$route.query.size)
    }
    if (this.$route.query.page) {
      this.currentPage = parseInt(this.$route.query.page)
    }
    this.getBoards()
  }
}
</script>

<style scoped>
.header {
  display: flex;
  justify-content: flex-end;
  margin-bottom: 10px;
  gap: 10px;
}
.pagination {
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 10px;
  margin-top: 10px;
}
</style>